var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59691 9.09687V5.9029H1.40304C0.904291 5.9029 0.5 5.4987 0.5 4.99986C0.5 4.50121 0.904291 4.09682 1.40304 4.09682H4.59691V0.903041C4.59691 0.404291 5.00121 0 5.49996 0C5.99861 0 6.403 0.404291 6.403 0.903041V4.09682H9.59696C10.0956 4.09682 10.5 4.50121 10.5 4.99986C10.5 5.4987 10.0956 5.9029 9.59696 5.9029H6.403V9.09687C6.403 9.59571 5.99861 9.99991 5.49996 9.99991C5.00121 9.99991 4.59691 9.59571 4.59691 9.09687Z",
    fill: "#112299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSmall);
export default __webpack_public_path__ + "static/media/add_small.8bdb1b3a643e7f7c585482eda8e3913f.svg";
export { ForwardRef as ReactComponent };